export default "__VITE_ASSET__BCkxY6cf__"